<template>
  <div class="w-100">
    <b-col><hr></b-col>
    <b-button
      variant="primary"
      size="sm"
      class="float-right"
      @click="$emit('closeModal')"
      v-translate
    >
      Close
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'modalFooter'
}
</script>
